import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "xml:space": "preserve",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "M0 12C0 5.4 5.4 0 12 0s12 5.4 12 12-5.4 12-12 12S0 18.6 0 12",
  style: {"fill-rule":"evenodd","clip-rule":"evenodd","fill":"currentColor"}
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  d: "M17.8 7.7c-.2-.2-.5-.3-.8-.3s-.6.1-.8.3L10.1 14l-2.4-2.4c-.2-.2-.5-.3-.8-.3s-.6.1-.8.3c-.4.4-.4 1.1 0 1.5l3.2 3.2c.2.2.5.3.8.3s.6-.1.8-.3l6.9-7.1c.2-.2.3-.5.3-.8s-.1-.5-.3-.7",
  style: {"fill":"#fff"}
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }